import { render, staticRenderFns } from "./AromaProductCard.vue?vue&type=template&id=7f87d001&scoped=true"
import script from "./AromaProductCard.vue?vue&type=script&lang=js"
export * from "./AromaProductCard.vue?vue&type=script&lang=js"
import style0 from "./AromaProductCard.vue?vue&type=style&index=0&id=7f87d001&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f87d001",
  null
  
)

export default component.exports